import Api from "../utils/api-interceptor";


export const StartAssessment = async (obj: any) => {

  return Api.post("Tests/GetLastAdmissionDateAndCreateMasterTest", obj)
    .then((response) => {
      return response;
    }, (error) => {
    });
}

export const StartTest = async (obj: any) => {

  return Api.post("Tests/BeginTest", obj)
    .then((response) => {
      return response;
    }, (error) => {
    });
}
export const SearchPatientVisitDetails = async (obj: any) => {

  return Api.post("Patient/SearchPatientVisitDetails", obj)
    .then((response) => {
      return response;
    }, (error) => {
    });
}
export const GetListOfAssessmentsPerVisit = async (obj: any) => {

  return Api.post("Patient/GetListOfAssessmentsPerVisit", obj)
    .then((response) => {
      return response;
    }, (error) => {
    });
}
export const GenerateTestsReport = async (obj: any) => {

  return Api.post("Reports/GenerateTestsReport", obj)
    .then((response) => {
      return response;
    }, (error) => {
    });
}


export const GetReportComments = async (obj: any) => {

  return Api.post("Reports/GetReportComments", obj)
    .then((response) => {
      return response;
    }, (error) => {
    });
}


export const AddReportComments = async (obj: any) => {

  return Api.post("Reports/AddReportComments", obj)
    .then((response) => {
      return response;
    }, (error) => {
    });
}

export const CompleteTestPhase = async (obj: any) => {


  return Api.post("Tests/PhaseComplete", obj)
    .then((response) => {
      return response;
    }, (error) => {
    });
}

export const CompleteTest = async (obj: any) => {

  return Api.post("Tests/EndTestAndSaveComments", obj)
    .then((response) => {
      return response;
    }, (error) => {
    });
}